<template>
	<div class='clock-wrapper'>
		<div class='clock clock_style digits' :style="digitsStyle[1]">1</div>
		<div class='clock clock_style digits' :style="digitsStyle[2]">2</div>
		<div class='clock clock_style digits' :style="digitsStyle[3]">3</div>
		<div class='clock clock_style digits' :style="digitsStyle[4]">4</div>
		<div class='clock clock_style digits' :style="digitsStyle[5]">5</div>
		<div class='clock clock_style digits' :style="digitsStyle[6]">6</div>
		<div class='clock clock_style digits' :style="digitsStyle[7]">7</div>
		<div class='clock clock_style digits' :style="digitsStyle[8]">8</div>
		<div class='clock clock_style digits' :style="digitsStyle[9]">9</div>
		<div class='clock clock_style digits' :style="digitsStyle[10]">10</div>
		<div class='clock clock_style digits' :style="digitsStyle[11]">11</div>
		<div class='clock clock_style digits' :style="digitsStyle[12]">12</div>

		<div class='clock clock2 arr-hh' :style="hhStyle[0]"></div>
		<div class='clock clock2 arr-hh' :style="hhStyle[1]"></div>
		<div class='clock clock2 arr-hh' :style="hhStyle[2]"></div>
		<div class='clock clock2 arr-hh' :style="hhStyle[3]"></div>

		
		<div class='clock clock2 arr-mm' :style="mmStyle[0]"></div>
		<div class='clock clock2 arr-mm' :style="mmStyle[1]"></div>
		<div class='clock clock2 arr-mm' :style="mmStyle[2]"></div>
		<div class='clock clock2 arr-mm' :style="mmStyle[3]"></div>
		<div class='clock clock2 arr-mm' :style="mmStyle[4]"></div>
		<div class='clock clock2 arr-mm' :style="mmStyle[5]"></div>
 
		<div class='clock clock2 arr-ss' :style="ssStyle[0]"></div>
		<div class='clock clock2 arr-ss' :style="ssStyle[1]"></div>
		<div class='clock clock2 arr-ss' :style="ssStyle[2]"></div>
		<div class='clock clock2 arr-ss' :style="ssStyle[3]"></div>
		<div class='clock clock2 arr-ss' :style="ssStyle[4]"></div>
		<div class='clock clock2 arr-ss' :style="ssStyle[5]"></div>
		<div class='clock clock2 arr-ss' :style="ssStyle[6]"></div>
		<div class='clock clock2 arr-ss' :style="ssStyle[7]"></div>

	</div>	
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'clockComponent',
	//=========================================================================
	data() {
		return {
			digitsStyle: ['', '', '', '', '', '', '', '', '', '', '', '', ''],
			hhStyle: ['', '', '', ''],
			mmStyle: ['', '', '', '', '', ''],
			ssStyle: ['', '', '', '', '', '', '', ''],
			cosHH: {},
			sinHH: {},
			cosMM: {},
			sinMM: {},
			cosSS: {},
			sinSS: {}
		}
	},
	//=========================================================================
	created() {
		this.init_clock()
		this.start_clock()
	},
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		init_clock() {
			let X = 60
			let Y = 60
			let Rad = 45

			for (let i = 1; i < 13; i++)
			{
				this.digitsStyle[i] = 'top: ' + (Y - 15 + Rad * Math.sin(-1.51 + i * Math.PI / 6)) + 'px; left: ' + (X - 15 + Rad * Math.cos(-1.51 + i * Math.PI / 6)) + 'px;'
			}
		},
		//---------------------------------------------------------------------
		start_clock() {
			let X = 60
			let Y = 60
			let Rad = 45
			let time = new Date()
			let sec = -1.57 + Math.PI * time.getSeconds() / 30
			let min = -1.57 + Math.PI * time.getMinutes() / 30
			let hr = -1.57 + Math.PI * time.getHours() / 6 + Math.PI * parseInt(time.getMinutes()) / 360
			let i

			if (this.cosHH[hr] === undefined) this.cosHH[hr] = Math.cos(hr)
			if (this.sinHH[hr] === undefined) this.sinHH[hr] = Math.sin(hr)

			if (this.cosMM[min] === undefined) this.cosMM[min] = Math.cos(min)
			if (this.sinMM[min] === undefined) this.sinMM[min] = Math.sin(min)

			if (this.cosSS[sec] === undefined) this.cosSS[sec] = Math.cos(sec)
			if (this.sinSS[sec] === undefined) this.sinSS[sec] = Math.sin(sec)

			for (i = 0; i < 4; i++)
				this.$set(this.hhStyle, i, 'top: ' + (Y + i * Rad / 9 * this.sinHH[hr]) + 'px; left: ' + (X + i * Rad / 9 * this.cosHH[hr]) + 'px;')

			for (i = 0; i < 6; i++)
				this.$set(this.mmStyle, i, 'top: ' + (Y + i * Rad / 9 * this.sinMM[min]) + 'px; left: ' + (X + i * Rad / 9 * this.cosMM[min]) + 'px;')

			for (i = 0; i < 8; i++)
				this.$set(this.ssStyle, i, 'top: ' + (Y + i * Rad / 9 * this.sinSS[sec]) + 'px; left: ' + (X + i * Rad / 9 * this.cosSS[sec]) + 'px;')

			setTimeout(() => this.start_clock(), 500)
		}
		//---------------------------------------------------------------------
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
div.clock-wrapper {	
	position: relative;
	margin: 0 auto;
	width: 120px;
	height: 120px;
}
div.digits {
	color: #999;
}
div.arr-hh {
	background-color: black;
}
div.arr-mm {
	background-color: blue;
}
div.arr-ss {
	background-color: red;
}
div.clock_style {
	width: 30px;
	height: 30px;
	padding-top: 10px;
	font-size: 11px;
	font-weight: 500;
	text-align: center;
}
div.clock {
	position: absolute;
	top: 0px;
	left: 0px;
}
div.clock2 {
	position: absolute;
	width: 2px;
	height: 2px;
	font-size: 2px;
	transition: all 0.3s;
}
</style>



// WEBPACK FOOTER //
// clock.vue?a51053d0